/* MUST HAVE NO DEPENDENCIES */


/*
  switch videos for mobile and desktop
  responsive video script 
*/
function initResponsiveVideos() {
  let videos = document.querySelectorAll('.js-responsive-video');

  const windowSize = innerWidth;
  const mobileBreakpoint = 768

  let isMobile = windowSize > mobileBreakpoint ? false : true;

  videos.forEach(video => {
    let mobileSrc = video.dataset.mobileSrc;
    let src = video.dataset.src;

    let source = document.createElement('source');

    
    source.setAttribute('type', 'video/mp4');

    if (isMobile) {
      source.setAttribute('src', mobileSrc);
      if (video.dataset.mobilePoster) {
        video.setAttribute('poster', video.dataset.mobilePoster)
      }
    } else {
      source.setAttribute('src', src);
      if (video.dataset.desktopPoster) {
        video.setAttribute('poster', video.dataset.desktopPoster)
      }
    }

    video.appendChild(source);

    video.load();
  });
}

document.addEventListener("responsive-video", initResponsiveVideos);

initResponsiveVideos();